import { StyleSheet } from 'aphrodite/no-important';

import colors from '../../identity/colors';
import zIndex from '../../identity/zIndex';
import screens from '../../identity/screenSizes';
import spacingScale from '../../identity/spacingScale';

const navContainerBase = {
  backgroundColor: colors.WHITE,
  opacity: 1,
  transition: 'opacity 350ms ease-out',
  top: spacingScale.DESKTOP.X_LARGE - 16,
  left: '7.7%',
  zIndex: zIndex.nav,

  [screens.DESKTOP_HD]: {
    top: spacingScale.DESKTOP_HD.X_LARGE - 16,
  },

  [screens.TABLET]: {
    display: 'none',
  },
};

export default StyleSheet.create({
  navContainer: {
    ...navContainerBase,
    position: 'absolute',
  },

  navContainerFixed: {
    ...navContainerBase,
    position: 'fixed',
  },

  ul: {
    listStyle: 'none',
    padding: '0 0 0 112px',
    textAlign: 'right',

    ':before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      borderRight: '5px solid #666E79',
      right: '0px',
      top: '16px',
      bottom: '16px',
      width: '20px',
      opacity: 0.1,
      lineHeight: 0,
    },
  },

  scrollBar: {
    display: 'block',
    position: 'absolute',
    right: '0px',
    top: '16px',
    height: '40px',
    width: '5px',
    backgroundColor: colors.BLUE_PRIMARY,
    transition: 'transform 250ms ease-out .5s',
  },

  mediaFade: {
    opacity: '0 !important',
  },
});



// WEBPACK FOOTER //
// ./src/components/Navigation/styles.js